import GoalCategoryItem from './GoalCategoryItem';

export default GoalCategoryItem;
